import request from '@/utils/request'

// 查询分销比例配置分页
export function fetchProportionList(query) {
  return request({
    url: '/upkeep/distributor/ratio/page',
    method: 'get',
    params: query,
  })
}

// 新增分销比例配置
export function addProportionConfig(data) {
  return request({
    url: '/upkeep/distributor/ratio/add',
    method: 'post',
    data: data,
  })
}

// 查询维修区域列表
export function fetchAreaList(query) {
  return request({
    url: '/upkeep/area/list',
    method: 'get',
    params: query,
  })
}

// 启用/禁用分销比例配置
export function toggleProportionEnable(data) {
  return request({
    url: '/upkeep/distributor/ratio/edit/enable',
    method: 'post',
    data: data,
  })
}

// 获取分销比例配置详情
export function getProportionDetail(id) {
  return request({
    url: '/upkeep/distributor/ratio/detail',
    method: 'get',
    params: { id },
  })
}
